module.exports = __webpack_public_path__ + "img/ai-companion.5515efee.svg";